// Weather.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';

import MyPage from "../MyPage.js";
import SubTabsWeather from "../SubTabsWeather.js";

const WeatherDaily = () => {
  const [weatherData, setWeatherData] = useState(null);
  //const apiKey = '4dd9cf3482ca55a0805efffda6a7927d';
  const apiKey = '99fdc121f2827dcd2feee78977e51b70';

  useEffect(() => {
    const fetchWeatherData = async () => {
      try {
        const response = await axios.get(
          `https://api.openweathermap.org/data/2.5/weather?lat=48.8245&lon=2.2743&appid=${apiKey}`
        );
        setWeatherData(response.data);
      } catch (error) {
        console.error('Error fetching weather data:', error);
      }
    };

    fetchWeatherData();
  }, []);

  return (
    <div style={{ paddingLeft: '25px' }}>
      <MyPage />
      <SubTabsWeather />
      {weatherData && (
        <div style={{ paddingLeft: '25px', paddingTop: '20px' }}>
          <h2>Weather in {weatherData.name}</h2>
          <p>Temperature: {weatherData.main.temp - 273.15}°C</p>
          <p>Description: {weatherData.weather[0].description}</p>
        </div>
      )}
    </div>
  );
};

export default WeatherDaily;
